import { useMutation, useQueryClient } from "@tanstack/react-query";
import { ServerInferRequest } from "@ts-rest/core";
import { getBackendAPIClient } from "../../../lib/backendAPIClient";
import { manualTransactionContract } from "../../../common/contracts/manual-transaction.contract";

export const manualTransactionContractClient = getBackendAPIClient(
    manualTransactionContract,
);

export function useTransactionsCreation() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (
            data: ServerInferRequest<
                typeof manualTransactionContract.createManualTransactions
            >["body"],
        ) =>
            manualTransactionContractClient.createManualTransactions({
                body: data,
            }),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["transactions"],
            });
        },
    });
}
